import { Anchor, FileInput, Loader, Text } from '@mantine/core';
import React, { useContext, useState } from 'react'
import { ConfigContext } from '../../contexts';
import * as ExcelJS from 'exceljs';
import { BaseResult, BulkAddClientRequest } from '../../types';
import { getCountriesList } from '../../utils';
import { showNotification } from '@mantine/notifications';
import { IconX } from '@tabler/icons-react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../helpers/firebaseContext';
import { modals } from '@mantine/modals';


const UploadCustomerModal = () => {
    const [file, setFile] = useState<File | null>(null);
    const configContext = useContext(ConfigContext);
    const [loading, setLoading] = useState(false);
    const handleFileUpload = async (file: File) => {
        const workbook = new ExcelJS.Workbook();
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);

        reader.onload = async () => {
            const buffer = reader.result as ArrayBuffer;
            await workbook.xlsx.load(buffer);

            let customers: BulkAddClientRequest["customers"] = [];
            const localErrors: string[] = [];

            const worksheet = workbook.worksheets[0];
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) return; // Skip header row
                let customerObj: any = {
                    customerType: "individual"
                };

                let civilID = row.getCell('A').value?.toString().trim();
                if (!civilID) {
                    localErrors.push('Customer ID is missing at row ' + rowNumber);
                    return;
                }
                civilID = civilID.replace(/\//g, '-');
                customerObj["civilID"] = civilID;

                let kfhTradeID = row.getCell('B').value?.toString().trim();
                if (!kfhTradeID) {
                    localErrors.push('KFH Trade ID is missing at row ' + rowNumber);
                    return;
                }
                customerObj["kfhtrade_id"] = kfhTradeID;

                let nameEn = row.getCell('C').value?.toString().trim();
                if (!nameEn) {
                    localErrors.push('Customer Name (English) is missing at row ' + rowNumber);
                    return;
                }
                customerObj["name_en"] = nameEn;
                let nameAr = row.getCell('D').value?.toString().trim();
                if (!nameAr) {
                    localErrors.push('Customer Name (Arabic) is missing at row ' + rowNumber);
                    return;
                }
                customerObj["name_ar"] = nameAr;

                let mobile = row.getCell('E').value?.toString().trim();
                if (!mobile) {
                    localErrors.push('Mobile Number is missing at row ' + rowNumber);
                    return;
                }
                customerObj["mobile"] = mobile;

                let nationality = row.getCell('F').value?.toString().trim();
                if (!nationality) {
                    localErrors.push('Nationality is missing at row ' + rowNumber);
                    return;
                } else {
                    const countires = getCountriesList();
                    if (!countires.find((countryObj) => countryObj.value === nationality)) {
                        localErrors.push('Invalid Nationality at row ' + rowNumber);
                        return;
                    }
                }
                customerObj["nationality"] = nationality;
                // check segment (optional)
                const segment = row.getCell('G').value?.toString().trim();
                if (segment) {
                    const validSegments = configContext?.segments?.segmentList?.map(seg => seg.name) || [];
                    if (!validSegments.includes(segment)) {
                        localErrors.push('Invalid Segment at row ' + rowNumber);
                    } else {
                        customerObj["segment"] = segment;
                    }
                }

                customers.push(customerObj);
            });

            if (localErrors.length > 0) {


                showNotification({
                    id: "error",
                    color: "red",
                    icon: <IconX />,
                    withBorder: true,
                    message: (
                        <Text>
                            <Text fw={700} span>Processing Errors:</Text> {localErrors.join(', ')}
                        </Text>
                    ),
                    autoClose: false,
                });
                setLoading(false);

            } else {

                const bulkAddClient = httpsCallable<BulkAddClientRequest, BaseResult>(functions, 'bulkAddClient');
                const { data: bulkAddResult } = await bulkAddClient({ customers: customers });
                console.log("bulkAddResult ==========>>", bulkAddResult);

                if (bulkAddResult.status === "success") {
                    if (bulkAddResult.data) {
                        showNotification({
                            id: "warning",
                            color: "yellow",
                            icon: <IconX />,
                            withBorder: true,
                            message: (
                                <Text>
                                    <Text fw={700} span>Some Client failed to add </Text>
                                    {bulkAddResult.data?.map((failedCustomer: any) => {
                                        return <>
                                            <Text fw={700} > {failedCustomer?.customer?.civilID} </Text>
                                            <Text span> {failedCustomer?.error} </Text>
                                        </>
                                    })}
                                </Text>
                            ),
                            autoClose: false,
                        });
                    }
                    else {

                        showNotification({
                            id: "success",
                            color: "green",
                            icon: <IconX />,
                            withBorder: true,
                            message: (
                                <Text>
                                    <Text fw={700} span>Success</Text>
                                </Text>
                            ),
                            autoClose: false,
                        });
                    }
                    modals.closeAll();
                }
                else {
                    showNotification({
                        id: "error",
                        color: "red",
                        icon: <IconX />,
                        withBorder: true,
                        message: (
                            <Text>
                                <Text fw={700} span>Error adding cleints:</Text>{bulkAddResult.message || "something went wrong"}
                            </Text>
                        ),
                        autoClose: false,
                    });
                }
                setLoading(false);
            }
        };
    };
    return (
        <>
            <Anchor
                href="https://storage.googleapis.com/public-pdfs/Customers%20Bulk%20%20Upload%20Sheet-%20Template.xlsx"
                download
                target="_blank"
                rel="noopener noreferrer"
            >
                Download Template
            </Anchor>
            <FileInput
                label="Upload Excel File"
                placeholder={loading ? <Loader /> : <>
                    Choose file</>}
                accept=".xlsx"
                value={file}
                disabled={loading}
                onChange={(file) => {
                    // setFile(file);
                    setLoading(true);
                    if (file) {
                        handleFileUpload(file);
                    }
                }}
            />
            {/* {processingErrors.length > 0 && <Text><Text fw={700} span>Processing Errors:</Text> {processingErrors.join(', ')}</Text>} */}
        </>
    )
}

export default UploadCustomerModal